module.exports = __webpack_public_path__ + "img/TruVito-Trace.60dfacad.png";